// 审核中心的知识信息
import KngInfo from './src/main';

/* istanbul ignore next */
KngInfo.install = function(Vue) {
  Vue.component(KngInfo.name, KngInfo);
};

export default KngInfo;
